import type { ConfigRequest } from '@pba/react-utils';
import { type ApiClientResponse, type CursorPaginationRailsParams, apiClient, routes } from 'common/services';
import type { ContentObjectListDataObject } from 'models/service';

type BookmarksFeedRequest = CursorPaginationRailsParams;

export const getBookmarksFeed = async ({ config }: ConfigRequest<BookmarksFeedRequest>) =>
  apiClient.get<ContentObjectListDataObject[], ApiClientResponse<ContentObjectListDataObject[]>>(
    routes.contentObjects.bookmarks,
    config,
  );
